export const PATH_MUTATIONS = Object.freeze({
    SET_PATHS: "SET_PATHS",
    SET_USER_PATHS: "SET_USER_PATHS",
    UNSET_USER_PATHS: "UNSET_USER_PATHS",
    UNSET_PATHS: "UNSET_PATHS",
    SET_SELECTED_PATHS: "SET_SELECTED_PATHS",
    UNSET_SELECTED_PATHS: "UNSET_SELECTED_PATHS"
});